export default __webpack_public_path__ + "static/media/bedroom2.5d8a9ca5.webp";